module.exports = __webpack_public_path__ + "static/img/img02@2x.4f6da89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img02@2x.png
// module id = nUTJ
// module chunks = 174